import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    page?: MobiusPageProps;
    footerWrapper?: InjectableCss;
}

export const footerStyles: FooterStyles = {
    footerWrapper: {
        css: css`
            background-color: #efefef;
            padding: 15px;
            margin-top: 3rem;
            a, a *{
                color: #000 !important;
            }
        `,
    },
    page: {
        css: css`
        background-color: #efefef;
        padding: 2rem 0 !important;
    `,
    }
    
};
const styles = footerStyles;

const Footer = ({ id }: PageProps) => (
    <StyledWrapper {...styles.footerWrapper}>
        <Page as="footer" isFooter={true} {...styles.page}>
            <Zone contentId={id} zoneName="Content" />
            <CookiePrivacyPolicyPopup />
        </Page>
    </StyledWrapper>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
